module.exports = __webpack_public_path__ + "img/1697740098473.680b6092.jpg";